import { createIcon } from '../createIcon';

export const AnsibeTowerIconConfig = {
  name: 'AnsibeTowerIcon',
  height: 390,
  width: 390,
  svgPath: 'M402.6,214.7c0,103.9-84.2,188.1-188.1,188.1c-103.9,0-188.1-84.2-188.1-188.1  c0-103.9,84.2-188.1,188.1-188.1C318.4,26.6,402.6,110.8,402.6,214.7z M304.1,289.3l-74.9-180.2c-2.1-5.2-6.4-7.9-11.6-7.9c-5.2,0-9.8,2.8-11.9,7.9l-82.2,197.7h28.1l32.5-81.5  l97.1,78.4c3.9,3.2,6.7,4.6,10.4,4.6c7.3,0,13.7-5.5,13.7-13.4C305.4,293.6,305,291.5,304.1,289.3z M217.7,141.5l48.7,120.2  l-73.5-57.9L217.7,141.5z',
  yOffset: 20,
  xOffset: 20,
};

export const AnsibeTowerIcon = createIcon(AnsibeTowerIconConfig);

export default AnsibeTowerIcon;